var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shower") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M398.286,502a6,6,0,0,0,6-6V110.285a100.286,100.286,0,0,0-200.572,0V125.2h-75a21.024,21.024,0,0,0-21,21v6a21.024,21.024,0,0,0,21,21h162a21.024,21.024,0,0,0,21-21v-6a21.024,21.024,0,0,0-21-21h-75V110.285a88.286,88.286,0,0,1,176.572,0V496A6,6,0,0,0,398.286,502Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.714,193.847a6,6,0,0,0-12,0v12a6,6,0,1,0,12,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.714,193.847a6,6,0,0,0-12,0v36a6,6,0,1,0,12,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.714,193.847a6,6,0,0,0-12,0v12a6,6,0,1,0,12,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.714,193.847a6,6,0,0,0-12,0v12a6,6,0,1,0,12,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.714,193.847a6,6,0,0,0-12,0v36a6,6,0,1,0,12,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.714,229.847a6,6,0,0,0-12,0v72a6,6,0,0,0,12,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M251.714,253.847a6,6,0,0,0-12,0v24a6,6,0,0,0,12,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M287.714,229.847a6,6,0,0,0-12,0v72a6,6,0,0,0,12,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.714,229.847a6,6,0,0,0-12,0v72a6,6,0,0,0,12,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M179.714,253.847a6,6,0,0,0-12,0v24a6,6,0,0,0,12,0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M209.714,331.847a6,6,0,0,0-6,6v12a6,6,0,0,0,12,0v-12A6,6,0,0,0,209.714,331.847Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.714,295.847a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0v-48A6,6,0,0,0,245.714,295.847Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M281.714,331.847a6,6,0,0,0-6,6v12a6,6,0,0,0,12,0v-12A6,6,0,0,0,281.714,331.847Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M137.714,331.847a6,6,0,0,0-6,6v12a6,6,0,0,0,12,0v-12A6,6,0,0,0,137.714,331.847Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M173.714,295.847a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0v-48A6,6,0,0,0,173.714,295.847Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOush);
export default __webpack_public_path__ + "static/media/OUSH.3136104a.svg";
export { ForwardRef as ReactComponent };